import colors from 'vuetify/lib/util/colors';

const light = {
    primary50: '#E5EFF9',
    primary100: '#718195',
    primary200: '#C9DEF3',
    primary300: '#3F87D3',
    primary700: '#2766A7',
    primary800: '#4E637D',
    surface: '#EFF1F5',
    white: '#ffffff',
    secondary: colors.blueGrey.base,
    accent: colors.teal.base,
    error: colors.deepOrange.base,
    warning: colors.orange.darken2,
    //info: colors.cyan.base,
    success: colors.lightGreen.base,
    navDrawer: '#2a3042',
    cardListColor: '#2D7CD2',
    wsCard: '#FFFFFF',
    smCard: '#FFFFFF',
    reddish: '#F2B2A2',

    blue10Light: '#CFDBFF',
    blue30Light: '#7598FF',
    blue50Light: '#396AFF',
    blue70Light: '#2053EC',
    blue100Light: '#1340C7',

    blueGrey05Light: '#F1F3FA',
    blueGrey10Light: '#E6EAF5',
    blueGrey20Light: '#d6dbea',
    blueGrey30Light: '#BAC3DF',
    blueGrey40Light: '#B3BCD6',
    blueGrey50Light: '#A5B0CE',
    blueGrey60Light: '#8C97B8',
    blueGrey70Light: '#6B79A3',
    blueGrey80Light: '#546391',
    blueGrey90Light: '#283660',

    grey10Light: '#E3E7ED',
    grey50Light: '#A1ABb9',

    green10Light: '#d3faca',
    green30Light: '#81DE6D',
    green50Light: '#3DC11E',
    green70Light: '#2BA80F',
    green100Light: '#1F9106',

    indigo10Light: '#d3cfff',
    indigo30Light: '#9D94FF',
    indigo50Light: '#4B39FF',
    indigo100Light: '#1909BE',

    lightBlue10Light: '#cff2ff',
    lightBlue30Light: '#75DAFF',
    lightBlue50Light: '#39CAFF',
    lightBlue70Light: '#20B5EC',
    lightBlue100Light: '#1397C7',

    pink10Light: '#ffcfe1',
    pink30Light: '#FF75AA',
    pink50Light: '#FF3986',
    pink70Light: '#EC206E',
    pink100Light: '#C71358',

    purple10Light: '#f9d4ff',
    purple30Light: '#E78EF5',
    purple50Light: '#BA23CF',
    purple100Light: '#771A84',

    red10Light: '#fed9d9',
    red30Light: '#FF8B8A',
    red50Light: '#ff3c39',
    red70Light: '#E82825',
    red100Light: '#D61A18',

    orange10Light: '#ffe5cf',
    orange30Light: '#FFBB84',
    orange50Light: '#FF9139',
    orange70Light: '#F08630',
    orange100Light: '#D17225',

    yellow10Light: '#fbf1cb',
    yellow30Light: '#FDE382',
    yellow50Light: '#FFD539',
    yellow70Light: '#EDC635',
    yellow100Light: '#DBB631',

    teal10Light: '#c8f6e6',
    teal30Light: '#67E4B9',
    teal50Light: '#2AD397',
    teal70Light: '#38C291',
    teal100Light: '#2D9F77',

    primary: '#396AFF',
    primaryText: '#546391',
    secondaryText: '#283660',

    secondaryButton: '#E7EDFF',

    greyText: '#777777',
    details: '#F3F6FA',
    iconBlue: '#0B8DD9',
};

const dark = {
    primary: colors.blue.base,
    secondary: colors.blueGrey.base,
    accent: colors.teal.base,
    error: colors.deepOrange.base,
    //warning: colors.yellow.base,
    //info: colors.cyan.base,
    success: colors.lightGreen.base,
    navDrawer: '#2a3042',
    wsCard: '#506690',
    smCard: '#508FE2',
};

export { light, dark };
